import {textOperators, numberOperators, selectOperators} from '@src/assets/data/constants'

export const getOperatorByValue = (type, { operator, value, not }) => {
  let operators = {}
  if (_.includes(['text', 'textarea', 'email', 'phone'], type)) operators = textOperators
  if (_.includes(['number', 'integer', 'decimal'], type)) operators = numberOperators
  if (_.includes(['select', 'asyncSelect'], type)) operators = selectOperators
  return _.find(operators, _operator => {
    if (value === 'null' && not?.toString() === 'true') {
      return _operator.value === operator && _operator.not.toString() === not.toString() && _operator.null === true
    } else if (value === 'null') {
      return _operator.value === operator && _operator.null === true
    } else if (not?.toString() === 'true') {
      return _operator.value === operator && _operator.not.toString() === not.toString()
    } else {
      return _operator.value === operator
    }
  })
}